/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import { classNames } from '../../helpers/utils'

export default function SelectBox({ onSelect, defaultSelected, options }) {
    const [selected, setSelected] = useState(defaultSelected)

    useEffect(() => {
        setSelected(defaultSelected)
    }, [defaultSelected])

    useEffect(() => {
        onSelect(selected)
    }, [selected, onSelect])

    return (
        <Listbox value={selected} onChange={setSelected}>
            {({ open }) => (
                <>
                    <div className="relative">
                        <Listbox.Button className="relative w-full rounded-[8px] border border-[#E1DACE] bg-white py-[11px] pl-[14px] pr-10 text-left text-[13px] text-[#1A1D23] transition-all duration-150 focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15">
                            <span
                                className={classNames(
                                    selected
                                        ? 'font-medium text-[#1A1D23]'
                                        : 'text-gray-400',
                                    'block truncate',
                                )}>
                                {selected || 'Choose column'}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
                                <SelectorIcon
                                    className="h-4 w-4"
                                    aria-hidden="true"
                                />
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0">
                            <Listbox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-[10px] border border-[#E1DACE] bg-white py-1 text-[13px] shadow-[0_18px_40px_rgba(0,0,0,0.18),0_2px_6px_rgba(0,0,0,0.08)] focus:outline-none">
                                {options.map((option) => (
                                    <Listbox.Option
                                        key={option}
                                        className={({ active }) =>
                                            classNames(
                                                active
                                                    ? 'bg-[#FDF4EC] text-[#1A1D23]'
                                                    : 'text-[#1A1D23]',
                                                'relative cursor-default select-none py-[11px] pl-[14px] pr-9',
                                            )
                                        }
                                        value={option}>
                                        {({ selected, active }) => (
                                            <>
                                                <span
                                                    className={classNames(
                                                        selected
                                                            ? 'font-semibold'
                                                            : 'font-normal',
                                                        'block truncate',
                                                    )}>
                                                    {option}
                                                </span>

                                                {selected ? (
                                                    <span
                                                        className={classNames(
                                                            'absolute inset-y-0 right-0 flex items-center pr-3',
                                                            active
                                                                ? 'text-[#ED5C2F]'
                                                                : 'text-[#ED5C2F]',
                                                        )}>
                                                        <CheckIcon
                                                            className="h-4 w-4"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}
